<script setup lang="ts">
import type { TNewsAttachedOrganization } from '~/components/widget/news-attached-organizations/types'
import { WidgetOrganizationAsideContacts } from '~/components/widget/organization-aside-contacts'
import { EntityOrganizationLogo } from '~/components/entity/organization-logo'

const props = defineProps<{
  organizations?: TNewsAttachedOrganization[]
}>()
</script>

<template>
  <SidebarBlock
    v-if="props.organizations && props.organizations.length > 1"
    variant="white"
    :heading-text="$t('common.companies')"
  >
    <div v-for="item in props.organizations" :key="item.id">
      <div class="flex items-center gap-4">
        <EntityOrganizationLogo
          :src="item.logo"
          :alt="item.title"
          :to="item.url"
          class="min-w-[70px]"
        />

        <div>
          <NuxtLinkLocale
            v-if="item.url"
            :to="item.url"
            :aria-label="`${$t('common.more_about')} ${item.title}`"
            class="hover:underline"
          >
            <Heading tag="h3" class="h6">{{ item.title }}</Heading>
          </NuxtLinkLocale>
          <Heading v-else tag="h3" class="h6">{{ item.title }}</Heading>
        </div>
      </div>
    </div>
  </SidebarBlock>
  <WidgetOrganizationAsideContacts
    v-if="props.organizations && props.organizations.length === 1"
    :organization="props.organizations[0]"
    enable-link
  />
</template>
